export default "__VITE_ASSET__DgnheRPK__"